import { Column, Entity, PrimaryColumn } from "typeorm";

import { User } from "../../_objects/user";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";

/**
 * LoggedInUserSchema インターフェイス。
 */
export interface ILoggedInUserSchema {
  id: string;
  givenName: string;
  surname: string;
  initials: string;
  isAgreedTerms: boolean;
  accountEnabled: boolean;
  country: string;
  schemaVersion: string;
  tenantAttributes: string;
  currentNetworkMode: boolean;
  lastLoggedInDate: string;
  tenantId: string;
}

@Entity()
export class LoggedInUserSchema implements TenantIdSchemaBase, ILoggedInUserSchema {
  @PrimaryColumn()
  id: string;

  @Column({ nullable: true })
  givenName: string | null;

  @Column({ nullable: true })
  surname: string | null;

  @Column({ nullable: true })
  initials: string | null;

  @Column({ nullable: true })
  isAgreedTerms: boolean | null;

  @Column({ nullable: true })
  accountEnabled: boolean | null;

  @Column({ nullable: true })
  country: string | null;

  @Column({ nullable: true })
  schemaVersion: string | null;

  @Column({ nullable: true })
  tenantAttributes: string | null;

  @Column({ nullable: true })
  currentNetworkMode: boolean | null;

  @Column({ nullable: true })
  lastLoggedInDate: string | null;

  @Column({ nullable: true })
  tenantId: string | null;

  constructor(user: User | ILoggedInUserSchema, networkMode: boolean, lastLoggedInDate: string, tenantId: string) {
    if (user) {
      this.id = user.id;
      this.givenName = user.givenName;
      this.surname = user.surname;
      this.initials = user.initials;
      this.isAgreedTerms = user.isAgreedTerms;
      this.accountEnabled = user.accountEnabled;
      this.country = user.country;
      this.schemaVersion = user.schemaVersion;
      this.tenantAttributes = JSON.stringify(user.tenantAttributes);
    }

    this.currentNetworkMode = networkMode;
    this.lastLoggedInDate = lastLoggedInDate;
    this.tenantId = tenantId;
  }
}
